<template>
  <div class="flot-page">
    <!-- ==================== 概览头 ==================== -->
    <div class="flt-hero">
      <div class="flt-hero-l">
        <div class="flt-hero-title">
          <el-button icon="ArrowLeft" text @click="go({ path: '/formList' })">返回</el-button>
          <h2>抽签结果</h2>
          <span class="flt-hero-badge">抽签</span>
        </div>
        <p class="flt-hero-sub">
          抽签由服务端开奖，随机种子落库 ⇒ 同一「表单 + 种子」可完整复现结果，可审计。
          开奖是幂等的：已开奖再开只会返回既有结果，不会重抽。
        </p>
      </div>
      <div class="flt-hero-r">
        <el-button icon="Refresh" @click="refresh">刷 新</el-button>
        <el-button type="primary" icon="Trophy" :loading="drawing" :disabled="!query.formId" @click="draw">开 奖</el-button>
      </div>
    </div>

    <!-- ==================== 筛选条 ==================== -->
    <div class="flt-bar">
      <el-select v-model="query.formId" clearable filterable placeholder="请选择表单（开奖必选）"
                 class="flt-sel-form" @change="onFormChange">
        <el-option v-for="f in formOptions" :key="f.id" :label="f.title" :value="f.id"></el-option>
      </el-select>
      <el-button type="primary" icon="Search" @click="search">查询</el-button>
      <span class="flt-count">共 {{ pageTotal }} 条</span>
    </div>

    <!-- ==================== 结果表 ==================== -->
    <div class="flt-card">
      <el-table
          v-loading="listLoading"
          :data="tableData"
          :cell-style="{padding: '6px 0'}"
          row-key="id"
          class="flt-table">
        <el-table-column width="130" label="记录号">
          <template #default="scope">{{ scope.row.recordId || '—' }}</template>
        </el-table-column>
        <el-table-column min-width="120" label="提交人">
          <template #default="scope">
            {{ scope.row.studentName || scope.row.signerName || scope.row.submitterName || '—' }}
          </template>
        </el-table-column>
        <el-table-column width="140" label="手机号">
          <template #default="scope">{{ maskPhone(scope.row.phone) }}</template>
        </el-table-column>
        <el-table-column min-width="140" show-overflow-tooltip label="校区">
          <template #default="scope">{{ scope.row.campusName || '—' }}</template>
        </el-table-column>
        <el-table-column width="110" align="center" label="结果">
          <template #default="scope">
            <el-tag :type="scope.row.isWin ? 'success' : 'info'" size="small">
              {{ scope.row.isWin ? '已中签' : '未中签' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column width="180" label="开奖时间">
          <template #default="scope">{{ scope.row.drawnAt || '—' }}</template>
        </el-table-column>

        <template #empty>
          <div v-if="listFailed" class="flt-fail">
            <el-icon><WarningFilled /></el-icon>
            <p>{{ listError || '抽签结果加载失败' }}</p>
            <el-button type="primary" icon="RefreshRight" @click="selectList">重试</el-button>
          </div>
          <div v-else class="flt-empty">
            <el-icon><Checked /></el-icon>
            <p>{{ emptyText }}</p>
          </div>
        </template>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100]"
          :current-page="query.pageIndex"
          :page-size="query.pageSize"
          :total="pageTotal"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"></el-pagination>
    </div>
  </div>
</template>

<script>
import { formPage, formLotteryPage, formLotteryDraw } from '@/api/form';

export default {
  name: 'FormLottery',
  data() {
    return {
      listLoading: false,
      drawing: false,
      listFailed: false,
      listError: '',
      tableData: [],
      pageTotal: 0,
      formOptions: [],
      query: {
        pageIndex: 1,
        pageSize: 10,
        formId: null,
      },
    };
  },
  computed: {
    emptyText() {
      if (this.query.formId == null) return '请先在上方选择一张表单';
      return '该表单还没有抽签结果 —— 可能是尚未开奖，或该表单未开启抽签';
    },
  },
  methods: {
    /** 手机号脱敏：11 位手机号中间四位打码；其它格式原样返回（与 FormVerify 同口径） */
    maskPhone(phone) {
      const s = String(phone == null ? '' : phone);
      if (/^\d{11}$/.test(s)) return s.slice(0, 3) + '****' + s.slice(7);
      return s || '—';
    },
    loadFormOptions() {
      formPage({ pageIndex: 1, pageSize: 200, keyword: '' }).then(val => {
        if (val && val.code === 200) {
          const records = (val.data && val.data.records) || [];
          this.formOptions = records.map(r => ({ id: r.id, title: r.title || ('#' + r.id) }));
        }
      }).catch(() => { /* 下拉拉取失败不影响主列表 */ });
    },
    selectList() {
      if (this.query.formId == null) {
        this.tableData = [];
        this.pageTotal = 0;
        return;
      }
      this.listLoading = true;
      this.listFailed = false;
      this.listError = '';
      formLotteryPage(this.query).then(val => {
        this.listLoading = false;
        if (val && val.code === 200) {
          this.tableData = (val.data && val.data.records) || [];
          this.pageTotal = (val.data && val.data.total) || 0;
        } else {
          this.tableData = [];
          this.pageTotal = 0;
          this.listFailed = true;
          this.listError = (val && val.message) || '抽签结果加载失败';
        }
      }).catch((err) => {
        this.listLoading = false;
        this.tableData = [];
        this.pageTotal = 0;
        this.listFailed = true;
        this.listError = (err && err.message) || '抽签结果加载失败，请检查网络';
      });
    },
    refresh() {
      if (this.query.formId != null) this.selectList();
      else this.tableData = [];
    },
    search() {
      this.query.pageIndex = 1;
      this.refresh();
    },
    onFormChange() {
      this.query.pageIndex = 1;
      this.refresh();
    },
    draw() {
      if (this.query.formId == null) {
        this.$message.warning('请先选择要开奖的表单');
        return;
      }
      const form = this.formOptions.find(f => f.id === this.query.formId);
      const formName = (form && form.title) || ('#' + this.query.formId);
      this.$confirm(
          `将对「${formName}」执行开奖。开奖由服务端随机抽取并落库，【开奖后不可重抽】——`
          + '已开奖的表单再点开奖只会返回既有结果，不会重新抽取。是否继续？',
          '开奖确认（不可逆）',
          { type: 'warning', confirmButtonText: '确认开奖', cancelButtonText: '取消' }
      ).then(() => {
        this.drawing = true;
        formLotteryDraw({ formId: this.query.formId }).then(val => {
          this.drawing = false;
          if (val && val.code === 200) {
            this.$message.success('开奖完成');
            this.selectList();
          } else {
            this.$message.warning((val && val.message) || '开奖失败');
          }
        }).catch((err) => {
          this.drawing = false;
          this.$message.error((err && err.message) || '开奖失败，请稍后重试');
        });
      }).catch(() => {});
    },
    handleSizeChange(size) {
      this.query.pageSize = size;
      this.query.pageIndex = 1;
      this.selectList();
    },
    handlePageChange(index) {
      this.query.pageIndex = index;
      this.selectList();
    },
    go(target) {
      const p = this.$router.push(target);
      if (p && typeof p.catch === 'function') {
        p.catch(err => {
          const msg = (err && err.message) || '未知错误';
          this.$message.error(`打开页面失败：${msg}（若是改版后首次进入，请按 Ctrl+F5 强制刷新）`);
        });
      }
    },
  },
  created() {
    const q = this.$route.query.formId;
    this.query.formId = (q != null && q !== '' && !Number.isNaN(Number(q))) ? Number(q) : null;
    this.loadFormOptions();
    this.selectList();
  },
};
</script>

<style scoped>

/* @form-tokens:start */
/* ======================= 表单模块设计令牌（v3.11 视觉统一）=======================
 * ★ 本块在多个表单页各存一份（CSS 变量按作用域隔离，无法跨 scoped 共享）。
 *   改配色的唯一入口 = D:/tmp/shot/form_tokens.py 的 TOKEN_BLOCK，改完重跑该脚本
 *   一键同步；**不要手改单页**，否则多份会漂移。
 * ★ 为什么不放全局 :root：--el-color-primary 一旦全局生效会波及后台所有模块
 *   （订单 / 教练 / 财务…）。本模块只对「表单」相关页负责，故挂在页面根容器上，
 *   作用域精确、零外溢。
 * ========================================================================== */
.flot-page {
  --el-color-primary: #8dc63f;
  --el-color-primary-light-3: #afd779;
  --el-color-primary-light-5: #c6e39f;
  --el-color-primary-light-7: #ddeec5;
  --el-color-primary-light-8: #e8f4d9;
  --el-color-primary-light-9: #f4f9ec;
  --el-color-primary-dark-2: #719e32;

  /* —— 文字五档（严格对齐 Element 灰阶） —— */
  --yh-t1: #303133; /* 主文字 */
  --yh-t2: #606266; /* 常规 */
  --yh-t3: #909399; /* 次要 */
  --yh-t4: #a8abb2; /* 占位 */
  --yh-t5: #c0c4cc; /* 禁用 */

  /* —— 主色四档 —— */
  --yh-theme: #8dc63f;
  --yh-theme-d: #7cad37;
  --yh-theme-dd: #5f9427;
  --yh-theme-l: #eef7e2;
  --yh-theme-ll: #f6fbef;

  /* —— 面与线 —— */
  --yh-bg: #f5f7fa;
  --yh-fill: #fafbfc;
  --yh-line: #ebeef5;
  --yh-line-d: #dcdfe6;
  --yh-divide: #f2f3f5;

  /* —— 圆角五档 —— */
  --yh-r-xs: 4px;
  --yh-r-sm: 6px;
  --yh-r: 8px;
  --yh-r-lg: 12px;
  --yh-r-pill: 999px;
}
/* @form-tokens:end */

.flot-page {
  padding: 16px 20px 30px;
  min-height: 100%;
  background-color: #f5f7fa;
  box-sizing: border-box;
}

/* ==================== 概览头 ==================== */
.flt-hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
  background: #fff;
  border-radius: var(--yh-r-lg);
  padding: 16px 20px;
  margin-bottom: 14px;
  box-shadow: 0 1px 4px rgba(0, 0, 21, 0.06);
}

.flt-hero-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.flt-hero-title h2 {
  margin: 0;
  font-size: 19px;
  font-weight: 600;
  color: var(--yh-t1);
}

.flt-hero-badge {
  padding: 1px 8px;
  border-radius: var(--yh-r-pill);
  background: var(--yh-theme-l);
  color: var(--yh-theme-dd);
  font-size: 12px;
}

.flt-hero-sub {
  margin: 6px 0 0;
  max-width: 780px;
  font-size: 12px;
  line-height: 1.8;
  color: var(--yh-t3);
}

.flt-hero-r {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  flex: 0 0 auto;
}

/* ==================== 筛选条 ==================== */
.flt-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  background: #fff;
  border-radius: var(--yh-r-lg);
  padding: 12px 16px;
  margin-bottom: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 21, 0.06);
}

.flt-sel-form {
  width: 240px;
}

.flt-count {
  margin-left: auto;
  font-size: 12px;
  color: var(--yh-t3);
}

/* ==================== 表格卡 ==================== */
.flt-card {
  background: #fff;
  border-radius: var(--yh-r-lg);
  padding: 6px 12px 14px;
  box-shadow: 0 1px 4px rgba(0, 0, 21, 0.06);
}

.flt-table :deep(.el-table__inner-wrapper::before) {
  display: none;
}

.flt-table :deep(.el-table__header th) {
  background: var(--yh-fill);
  color: var(--yh-t2);
  font-weight: 600;
}

.flt-table :deep(.el-table__row:hover > td) {
  background: var(--yh-theme-ll) !important;
}

.pagination {
  margin-top: 16px;
  text-align: right;
}

/* 空态 / 失败态 */
.flt-empty,
.flt-fail {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 26px 0 12px;
}

.flt-empty .el-icon,
.flt-fail .el-icon {
  font-size: 32px;
  color: #dcdfe6;
}

.flt-fail .el-icon {
  color: #e6a23c;
}

.flt-empty p,
.flt-fail p {
  margin: 0;
  font-size: 13px;
  color: var(--yh-t4);
}
</style>
